import "@assets/styles/index.scss";

import {memo, useState, useEffect, createContext} from "react";

import "./App.scss";

import {Navigate, Route, Routes, useLocation} from "react-router-dom";

import {useTranslation} from "react-i18next";

import i18n from "i18next";

import "@/i18n";
import Start from "@/Start";

import {checkResponse} from "@/api/request";
import {restoreProgress} from "@/actionCreators";
import {useDispatch} from "react-redux";
import {clearProgress, getResponseIdFromSearch, loadProgress} from "@/utils/progressStorage";
import {getLangFromPath} from "@/utils/lang";
import OpenGraph from "@/components/OpenGraph/OpenGraph";

export const AppContext = createContext({});

const App = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const [lang, setLang] = useState("ua");
    const [playedStatus, setPlayedStatus] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [responseId, setResponseId] = useState("");
    const [agreementPassed, setAgreementPassed] = useState(false);

    const markAgreementPassed = () => {
        setAgreementPassed(true);
    };

    const context = {
        lang,
        setLang,
        isLoading,
        setIsLoading,
        playedStatus,
        setPlayedStatus,
        responseId,
        setResponseId,
        agreementPassed,
        markAgreementPassed,
    };

    useEffect(() => {
        const init = async () => {
            const id = getResponseIdFromSearch(location.search);
            const langFromPath = getLangFromPath(location.pathname);
            let isPlayed = false;

            setLang(langFromPath);
            i18n.changeLanguage(langFromPath);

            if (id) {
                try {
                    const response = await checkResponse(id);

                    if (response?.data?.message === true) {
                        setResponseId(id);
                    } else {
                        isPlayed = true;
                        setPlayedStatus(true);
                    }
                } catch (e) {
                    isPlayed = true;
                    setPlayedStatus(true);
                }
            }

            if (isPlayed) {
                clearProgress(id);
            } else {
                const saved = loadProgress(id);

                if (saved?.pageReducer) {
                    dispatch(restoreProgress(saved.pageReducer));
                    setAgreementPassed(saved.agreementPassed ?? true);
                }
            }

            setIsLoading(false);
        };

        init();
    }, []);

    return (
        <div className="App">
            <OpenGraph/>
            <AppContext.Provider value={context}>
                <p className="App__rotate-hint">{t("Please rotate your screen")}</p>
                <Routes>
                    <Route path="/" element={<Start/>}/>
                    <Route path="/es" element={<Start/>}/>
                    <Route path="/ua" element={<Start/>}/>
                    <Route path="/ru" element={<Start/>}/>
                    <Route path="*" element={<Navigate to={"/"} replace/>}/>
                </Routes>
            </AppContext.Provider>
        </div>
    );
};

export default memo(App);
